'use strict';

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  tagName: 'li',
  template: require('./templates/item.hbs'),

});
